import { toast } from "react-toastify";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import ToastElement from "../../components/toast";
import { parseMessage } from "../../helpers/util";
import TableDataService from "../../services/table-data-service";
import UserService from "../../services/user-service";
import {
  ADD_USER,
  CHANGE_PASSWORD,
  DELETE_MULTIPLE_USER,
  DELETE_USER,
  EDIT_USER,
  GET_ALL_USER,
  GET_USER,
  GET_USER_LIST,
  RESEND_VERIFICATION_CODE,
} from "../actions";
import {
  addUserError,
  addUserSuccess,
  changePasswordError,
  changePasswordSuccess,
  deleteMultipleUserError,
  deleteMultipleUserSuccess,
  deleteUserError,
  deleteUserSuccess,
  editUserError,
  editUserSuccess,
  getAllUserError,
  getAllUserSuccess,
  getUserError,
  getUserList,
  getUserListError,
  getUserListSuccess,
  getUserSuccess,
  resendVerificationCodeError,
  resendVerificationCodeSuccess,
} from "./action";

export function* watchGetAllUser() {
  yield takeEvery(GET_ALL_USER, getAllUser);
}

const getAllUserAsync = async () => {
  return UserService.getAllUser();
};

function* getAllUser() {
  try {
    const response = yield call(getAllUserAsync);
    if (response.data.success) {
      yield put(getAllUserSuccess(response.data.data));
    } else {
      toast.error(
        <ToastElement type="error" message={response.data.message} />,
        { containerId: "default", position: "bottom-right" }
      );
      yield put(getAllUserError(response.data.message));
    }
  } catch (error) {
    toast.error(
      <ToastElement type="error" message={error.response.data.message} />,
      { containerId: "default", position: "bottom-right" }
    );
    yield put(getAllUserError(error.response.data.message));
  }
}

export function* watchGetUserList() {
  yield takeEvery(GET_USER_LIST, getUserListAc);
}

const getUserListAsync = async (dbParam) => {
  return TableDataService.getAllData(
    "users",
    dbParam?.orgId || "",
    dbParam?.search || "",
    dbParam?.searchFields || "",
    dbParam?.sortOrder || "",
    dbParam?.page || 1,
    dbParam?.pageSize || 10,
    dbParam?.activeCol || "",
    dbParam?.statusId || null
  );
};

function* getUserListAc({ payload }) {
  try {
    const response = yield call(getUserListAsync, payload.dbParam);
    if (response.data.success) {
      yield put(getUserListSuccess(response.data));
    } else {
      toast.error(
        <ToastElement type="error" message={response.data.message} />,
        { containerId: "default", position: "bottom-right" }
      );
      yield put(getUserListError(response.data.message));
    }
  } catch (error) {
    toast.error(
      <ToastElement type="error" message={error.response.data.message} />,
      { containerId: "default", position: "bottom-right" }
    );
    yield put(getUserListError(error.response.data.message));
  }
}

export function* watchResendVerificationCode() {
  yield takeEvery(RESEND_VERIFICATION_CODE, resendVerificationCode);
}

const resendVerificationCodeAsync = async (id) => {
  return UserService.resendVerificationCode(id);
};

function* resendVerificationCode({ payload }) {
  // const customToastId = toast.info(
  //   <ToastElement
  //     type="info"
  //     message={i18n.t("USER.RESEND_VERIFICATION_CODE_INFO_LABEL")}
  //   />,
  //   {
  //     containerId: "custom",
  //   }
  // );
  try {
    const response = yield call(resendVerificationCodeAsync, payload.userId);
    if (response.data.success) {
      // toast.dismiss(customToastId);
      toast.success(
        <ToastElement type="success" message={response.data.message} />,
        { containerId: "default", position: "bottom-right" }
      );
      yield put(
        resendVerificationCodeSuccess(
          response.data.success,
          response.data.message
        )
      );
      // Fetch updated user list
      yield put(getUserList({}));
    } else {
      // toast.dismiss(customToastId);
      toast.error(
        <ToastElement type="error" message={response.data.message} />,
        { containerId: "default", position: "bottom-right" }
      );
      yield put(resendVerificationCodeError(response.data.message));
    }
  } catch (error) {
    // toast.dismiss(customToastId);
    toast.error(
      <ToastElement type="error" message={error.response.data.message} />,
      { containerId: "default", position: "bottom-right" }
    );
    yield put(resendVerificationCodeError(error.response.data.message));
  }
}

export function* watchAddUser() {
  yield takeEvery(ADD_USER, addUser);
}

const addUserAsync = async (data) => {
  return UserService.addUser(data);
};

function* addUser({ payload }) {
  const { history, location } = payload;
  try {
    const response = yield call(addUserAsync, payload.userData);
    if (response.data.success) {
      toast.success(
        <ToastElement type="success" message={response.data.message} />,
        { containerId: "default", position: "bottom-right" }
      );
      yield put(addUserSuccess(response.data.success, response.data.message));
      history.push(`/user-management/user${location?.state?.locationSearch ?? ""}`);
    } else {
      toast.error(
        <ToastElement type="error" message={response.data.message} />,
        { containerId: "default", position: "bottom-right" }
      );
      yield put(addUserError(response.data.message));
    }
  } catch (error) {
    const respData = error?.response?.data
    const message = respData ?
      respData?.errors ? parseMessage(respData?.errors)
        : parseMessage(respData?.message) : error?.message
    toast.error(
      <ToastElement
        type="error"
        message={message}
      />,
      {
        containerId: "default", position: "bottom-right",
      }
    );
    yield put(addUserError(message));
  }
}

export function* watchGetUser() {
  yield takeEvery(GET_USER, getUser);
}

const getUserAsync = async (id) => {
  return UserService.getUser(id);
};

function* getUser({ payload }) {
  try {
    const response = yield call(getUserAsync, payload.userId);
    if (response.data.success) {
      yield put(getUserSuccess(response.data.data));
    } else {
      toast.error(
        <ToastElement type="error" message={response.data.message} />,
        { containerId: "default", position: "bottom-right" }
      );
      yield put(getUserError(response.data.message));
    }
  } catch (error) {
    toast.error(
      <ToastElement type="error" message={error.response.data.message} />,
      { containerId: "default", position: "bottom-right" }
    );
    yield put(getUserError(error.response.data.message));
  }
}

export function* watchEditUser() {
  yield takeEvery(EDIT_USER, editUser);
}

const editUserAsync = async (data, id) => {
  return UserService.editUser(data, id);
};

function* editUser({ payload }) {
  try {
    const response = yield call(
      editUserAsync,
      payload.userData,
      payload.userId
    );
    if (response.data.success) {
      toast.success(
        <ToastElement type="success" message={response.data.message} />,
        { containerId: "default", position: "bottom-right" }
      );
      yield put(editUserSuccess(response.data.success, response.data.message, payload?.userId, payload?.buildings, payload?.role));
      if (payload.history) {
        payload?.history?.push(`/user-management/user${payload.location?.state?.locationSearch ?? ""}`);
      }
      payload?.callback?.()
    } else {
      toast.error(
        <ToastElement type="error" message={response.data.message} />,
        { containerId: "default", position: "bottom-right" }
      );
      yield put(editUserError(response.data.message));
    }
  } catch (error) {
    const respData = error?.response?.data
    const message = respData ?
      respData?.errors ? parseMessage(respData?.errors)
        : parseMessage(respData?.message) : error?.message

    toast.error(
      <ToastElement
        type="error"
        message={message}
      />,
      { containerId: "default", position: "bottom-right" }
    );
    yield put(editUserError(message));
  }
}

export function* watchDeleteUser() {
  yield takeEvery(DELETE_USER, deleteUser);
}

const deleteUserAsync = async (id) => {
  return UserService.deleteUser(id);
};

function* deleteUser({ payload }) {
  try {
    const response = yield call(deleteUserAsync, payload.userId);
    if (response.data.success) {
      payload?.callback?.();
      toast.success(
        <ToastElement type="success" message={response.data.message} />,
        { containerId: "default", position: "bottom-right" }
      );
      yield put(
        deleteUserSuccess(response.data.success, response.data.message)
      );
      // Fetch updated user list
      yield put(getUserList({}));
    } else {
      yield put(deleteUserError(response.data.message));
    }
  } catch (error) {
    yield put(deleteUserError(error.response.data.message));
  }
}

export function* watchDeleteMultipleUser() {
  yield takeEvery(DELETE_MULTIPLE_USER, deleteMultipleUser);
}

const deleteMultipleUserAsync = async (ids) => {
  return UserService.deleteMultipleUser(ids);
};

function* deleteMultipleUser({ payload }) {
  try {
    const response = yield call(deleteMultipleUserAsync, payload.userIds);
    if (response.data.success) {
      toast.success(
        <ToastElement type="success" message={response.data.message} />,
        { containerId: "default", position: "bottom-right" }
      );
      yield put(
        deleteMultipleUserSuccess(response.data.success, response.data.message)
      );
      // Fetch updated user list
      yield put(getUserList({}));
    } else {
      yield put(deleteMultipleUserError(response.data.message));
    }
  } catch (error) {
    yield put(deleteMultipleUserError(error.response.data.message));
  }
}

export function* watchChangePassword() {
  yield takeEvery(CHANGE_PASSWORD, changePassword);
}

const changePasswordAsync = async (data) => {
  return UserService.changePassword(data);
};

function* changePassword({ payload }) {
  try {
    const response = yield call(
      changePasswordAsync,
      payload.changePasswordData
    );
    if (response.data.success) {
      toast.success(
        <ToastElement type="success" message={response.data.message} />,
        { containerId: "default", position: "bottom-right" }
      );
      yield put(
        changePasswordSuccess(response.data.success, response.data.message)
      );
    } else {
      toast.error(
        <ToastElement type="error" message={response.data.message} />,
        { containerId: "default", position: "bottom-right" }
      );
      yield put(changePasswordError(response.data.message));
    }
  } catch (error) {
    toast.error(
      <ToastElement
        type="error"
        message={parseMessage(
          error.response.data.errors
            ? error.response.data.errors
            : error.response.data.message
        )}
      />,
      { containerId: "default", position: "bottom-right" }
    );
    yield put(changePasswordError(error.response.data.message));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchGetAllUser),
    fork(watchGetUserList),
    fork(watchResendVerificationCode),
    fork(watchAddUser),
    fork(watchGetUser),
    fork(watchEditUser),
    fork(watchDeleteUser),
    fork(watchDeleteMultipleUser),
    fork(watchChangePassword),
  ]);
}
